export default __webpack_public_path__ + "static/IBMPlexSans-SemiBoldItalic-95f40275ab74914172fdafa2a6bee741.woff2";